
import DeviceMessage from "../../../assets/outline/DeviceMessage.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DeviceMessageIcon({ className, dataTestid = "DeviceMessageIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DeviceMessage data-testid={dataTestid} className={classes} {...rest} />
  );
}
